import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, Formik } from "formik";
import { get } from "lodash";
import React, { useEffect, useState, useContext } from "react";
import { Form } from "react-bootstrap";
import { required, sectionTypeOptions } from "../../utils";
import { FieldButtonGroup, FieldInput } from "../Forms";
import SliderPanel from "../SliderPanel";
import {
  manageMapperStore,
  MANAGE_MAPPER_POST_API_ERROR,
  setManageMapperToastInfo,
  setMapperPostResponse,
} from "../../contexts";
import { fixedWidthOutputMappingSave } from "../../services";

const AddNewSectionSliderPanel = (props) => {
  const {
    isOpen,
    index,
    setSections,
    sections,
    setSliderState,
    onDeleteSection,
    isSectionEdit,
    profileId,
  } = props;
  const { dispatch } = useContext(manageMapperStore);
  const isEdit = !(index == undefined || index == null);
  const [disabledKeys, setDisabledKeys] = useState([]);

  useEffect(() => {
    var isHeader = sections?.some((_) => _.sectionType === 0);
    var isTrailer = sections?.some((_) => _.sectionType === 2);
    if (isSectionEdit) {
      setDisabledKeys(["Header", "Generic", "Trailer"]);
    } else if (isHeader && isTrailer) {
      setDisabledKeys(["Header", "Trailer"]);
    } else if (isHeader) {
      setDisabledKeys(["Header"]);
    } else if (isTrailer) {
      setDisabledKeys(["Trailer"]);
    } else {
      setDisabledKeys([]);
    }
  }, [sections, isSectionEdit]);

  const onSave = (values, { setValues }) => {
    let data = isEdit
      ? sections.map((item, i) => {
          if (i == index)
            return {
              ...item,
              id: item.id ?? 0,
              name: values?.name,
              sectionType: values?.sectionType,
            };
          return item;
        })
      : [...sections, { id: 0, ...values }];
    setSections(data);
    fixedWidthOutputMappingSave({
      id: profileId ?? 0,
      fixedWidthOutputSections: data,
    })
      .then((response) => {
        let newValues = response?.fixedWidthOutputSections
          ?.filter((_) => !_.isDeleted)
          ?.map((item) => {
            return {
              ...item,
              fixedWidthOutputSectionFields: item.fixedWidthOutputSectionFields?.filter(
                (_) => !_.isDeleted
              ),
            };
          });
        let res = {
          ...response,
          fixedWidthOutputSections: newValues,
        };
        dispatch(setMapperPostResponse(res));
        dispatch(
          setManageMapperToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
      })
      .catch((error) => {
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
    setSliderState(!isOpen);
  };

  const onCancel = () => {
    setSliderState(!isOpen);
  };

  return (
    isOpen && (
      <Formik
        initialValues={{
          name: (isEdit && get(sections[index], "name", "")) || "",
          sectionType: isEdit ? get(sections[index], "sectionType", 1) : 1,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={onSave}
      >
        {({ values, setValues, handleChange, setFieldValue, handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <SliderPanel
                isOpen={isOpen}
                showCancelButton={true}
                showSave={true}
                showCancel={false}
                onSave={handleSubmit}
                onClose={onCancel}
                title={"Add New Section"}
                size={38}
                showDeleteButton={isEdit}
                onDelete={onDeleteSection}
                showHeader={true}
                header={"Add New Section"}
                headerClass="slider-title-case"
                showSeparator={true}
              >
                <div>
                  <Field
                    label="Enter the Section Name"
                    name={"name"}
                    type="text"
                    value={values["name"]}
                    onChange={handleChange}
                    component={FieldInput}
                    validate={required}
                    isRequired
                  />
                  <Field
                    isRequired
                    size="sm"
                    label="Section Type"
                    name={"sectionType"}
                    options={sectionTypeOptions}
                    selectedValue={values["sectionType"]}
                    component={FieldButtonGroup}
                    disabledValues={disabledKeys}
                    onChange={(value) => {
                      setFieldValue("sectionType", value);
                    }}
                  />
                </div>
              </SliderPanel>
            </Form>
          );
        }}
      </Formik>
    )
  );
};

export default AddNewSectionSliderPanel;
